const FormInputWithLabel = ({
  label,
  name,
  value = '',
  type = 'text',
  required = false,
  maxLength = 50,
  onChange,
  placeholder = '',
  wrapperClassName = '',
  labelClassName = '',
  inputClassName = '',
  valueClassName = '',
  style = {},
  inputStyle = {},
  error = ''
}) => {
  return (
    <div className={`${wrapperClassName}`} style={style}>
      <div className='d-flex align-items-center'>
        <label className={`fw-semibold mb-0 ${labelClassName}`} style={{width: '120px', display: 'inline-block', verticalAlign: 'middle'}}>
          {label}
          {required && <span className='text-danger'>*</span>}
        </label>

        <span className='fw-semibold ps-4 pe-2 pt-2' style={{verticalAlign: 'middle'}}>
          :
        </span>

        <div className='flex-grow-1' style={{position: 'relative'}}>
          <input
            type={type}
            name={name}
            maxLength={maxLength}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            className={`${inputClassName}`}
            style={{
              border: '1px solid #ddd',
              outline: 'none',
              padding: '10px',
              marginLeft: '10px',
              width: '100%',
              ...inputStyle
            }}
          />

          {/* Error message positioned absolutely */}
          {error && (
            <small className='text-danger d-block mt-1 mx-3' style={{position: 'absolute', bottom: '-20px', left: '0', width: '100%'}}>
              {error}
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormInputWithLabel;
